const FALSE = ["false", "no", "0", "off", false];
FALSE.is = (value) => FALSE.includes(value.toLowerCase());

const TRUE = ["true", "yes", "1", "on", true];
TRUE.is = (value) => TRUE.includes(value.toLowerCase());

export { FALSE, TRUE };
